import { CCD_ALL_DATA_ROLE, CCD_NO_CDMO_ROLE, CCD_NO_CRO_ROLE } from "../ccd-roles.constants"

export const askOurDocsRoles = {
  IndexPrefix: "dpe_geneai_index_"
}

export const askOurDocsMCRoles = {
  IndexPrefix: "dpe_geneai_mc_index_"
}

export const askOurDataRole = {
  prefix: "dpe_geneai_aodata_"
}

export const sva2Roles = {
  Index: "Services_Virtual_Assistant_Plus"
}

export const cvaRoles = {
  Index:"Commercial_Virtual_Assistant"
}

export const ccdRoles = [
  CCD_ALL_DATA_ROLE,CCD_NO_CRO_ROLE,CCD_NO_CDMO_ROLE
]

export const postDecommissionAccessRole = 'necromancy_access'

export const chatWidgetAccessRole = 'dpe_geneai_chatwidget_access_role'

export const chatKitLsgAccessRole = 'dpe_geneai_chatkit_lsg_access_role'

export const restrictedUsersRole = 'dpe_geneai_restricted_users'

export const hasRestrictedUsersRole = (roles?: string[] | null): boolean => {
  return roles?.includes(restrictedUsersRole) ?? false;
}
